export default __webpack_public_path__ + "static/media/loa_logo.1528d960.png";